import { useAuth } from "./useAuth";

/** Returns true only after profiles.is_admin has been confirmed. */
export const useAdmin = (): boolean => {
  const { isAdmin, adminLoaded } = useAuth();
  return adminLoaded && isAdmin;
};
